import { Entity } from "./entity";

export interface User extends Entity {
  lastname?: string
  username?: string
  password?: string
  email: string
  telephone?: string
  mobile?: string
  fonction?: string
  technical?: boolean
  avatar?: string
  fullName?: string
  roles?: string[]
}

export class UserExport {
  usrs: User[]
}

export function getUserExport(users: User[]): UserExport {
  const userExport = new UserExport();
  userExport.usrs = users;
  return userExport;
}